import { Checkbox } from "@ts-digital/vrc";
import moment from "moment";
import React from "react";
import { useSelector } from "react-redux";

const FulfilmentCreateFulfilments = props => {
  const { onChangeSelected, selected } = props;

  const fulfilments = useSelector(state => state.fulfilments);

  return (
    <div className="fulfilment-create-dialog-fulfilments-list">
      {fulfilments &&
        fulfilments.fulfilmentsPreset &&
        fulfilments.fulfilmentsPreset.map((fulfilment,index) => {
          return (
            <div
              key={index}
              className="fulfilment-create-dialog-fulfilments-list-item"
              id={
                "fulfilment-create-dialog-fulfilments-list-item_" +
                fulfilment.id
              }
            >
              <div className="fulfilment-create-dialog-fulfilments-list-item-row">
                <div>
                  <Checkbox
                    checked={selected.indexOf(fulfilment.id) > -1}
                    onClick={() => onChangeSelected(fulfilment.id)}
                  />
                </div>
                <div className="fulfilment-create-dialog-fulfilments-list-item-text-title">
                  {fulfilment.description}
                </div>
              </div>
              <div className="fulfilment-create-dialog-fulfilments-list-item-row">
                <div>&nbsp;</div>
                <div className="fulfilment-create-dialog-fulfilments-list-item-text-date">
                  {moment(fulfilment.deadline).format("DD MMMM YYYY")}
                </div>
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default FulfilmentCreateFulfilments;
